export default __webpack_public_path__ + "static/cache-policy-b7c2ce09ae7880ce0152279c30382c8c.png";